import { render, staticRenderFns } from "./KeywordFilter.vue?vue&type=template&id=3d462042&scoped=true&"
import script from "./KeywordFilter.vue?vue&type=script&lang=js&"
export * from "./KeywordFilter.vue?vue&type=script&lang=js&"
import style0 from "@/resources/styles/results.css?vue&type=style&index=0&id=3d462042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d462042",
  null
  
)

export default component.exports